import React from 'react'
import LottiePlayer from './media/lottiePlayer'
import Flex from './shared-styles/flexi'

export default function Loading({ text = "Loading in progress" }) {
  return (
    <Flex direction='column'>
      <LottiePlayer
        dot
        style={{ width: "600px", height: "300px" }}
        file={"https://lottie.host/1b7db493-3491-4844-bf58-71a407266937/uVe2FJm4lR.lottie"}
      />
      {text && <p style={{ marginTop: "-20px", fontSize: "20px", color: "grey" }}>{text}</p>}
    </Flex>
  )
}

